import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default class LinkList extends Component {
  render() {
    const icon = SelectionFactoryHelper.getFromSelectionFactory(this.props.icon)
    const topPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.topPadding)
    return (
      <div className={`link-list ${topPadding ? topPadding : ""}`}>
        <div className="headline">
          {this.props.iconUpload ? <img src={this.props.iconUpload} alt="icon" /> : icon ? <Svg iconName={icon} fillColor={"#071143"} /> : ""}
          <h2>{this.props.headline}</h2>
        </div>
        <ul>
          {this.props.links && this.props.links.length > 0
            ? this.props.links.map((link, index) => {
                const target = SelectionFactoryHelper.getFromSelectionFactory(link.linkTarget)
                return (
                  <li key={index} className="link-list--item">
                    <a href={link.linkUrl} target={target ?? null}>
                      {link.linkText}
                    </a>
                  </li>
                )
              })
            : ""}
        </ul>
      </div>
    )
  }
}
